import { observer } from 'mobx-react';
import React, { createContext, FC, useEffect, useState } from 'react';
import { IColProps } from 'src/interfaces';
import { CustomerContactsWidget, ContractorContactsWidget } from './components';
import { IUserContactsServiceProvider } from './service-provider';
import { UserContactsWidgetStore } from './store/UserContacts.store';

type TUserTypes = 'customer' | 'contractor' | 'employee' | 'partner';

interface IUserAddressesWidgetProps extends IColProps {
  id: string;
  provider: IUserContactsServiceProvider;
  userType: TUserTypes;
}

const UserTypeComponentMapping: Record<TUserTypes, FC<IColProps>> = {
  customer: CustomerContactsWidget,
  contractor: ContractorContactsWidget,
  employee: CustomerContactsWidget,
  partner: CustomerContactsWidget,
};

export const UserContactsStoreContext = createContext<UserContactsWidgetStore | null>(null);

export const UserContactsWidget: FC<IUserAddressesWidgetProps> = observer((props) => {
  const [store] = useState(() => new UserContactsWidgetStore(props.id, props.provider));

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    store.loadContactsByContractorId();
  }, [store]);

  const Component = UserTypeComponentMapping[props.userType];

  return (
    <UserContactsStoreContext.Provider value={store}>
      <Component col={props.col} />
    </UserContactsStoreContext.Provider>
  );
});
